import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import type { TableVariant } from '@onefootprint/ui';
import type { Subsection as SubsectionType } from '../../onboarding-data.types';
import DecryptedContent from './components/decrypted-content';
type BusinessInsightDisplayOptions = {
  tableVariant?: TableVariant;
  hideFilters?: boolean;
};
type OnboardingBusinessInsightProps = {
  selectedSubsection: SubsectionType;
  onboarding: EntityOnboarding;
  displayOptions?: BusinessInsightDisplayOptions;
};

/** Expects the onboarding's vault to be decrypted already. */
const OnboardingBusinessInsight = t0 => {
  const $ = _c(4);
  const {
    selectedSubsection,
    onboarding,
    displayOptions
  } = t0;
  let t1;
  if ($[0] !== displayOptions || $[1] !== onboarding.id || $[2] !== selectedSubsection) {
    t1 = <DecryptedContent onboardingId={onboarding.id} selectedSubsection={selectedSubsection} displayOptions={displayOptions} />;
    $[0] = displayOptions;
    $[1] = onboarding.id;
    $[2] = selectedSubsection;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export type { BusinessInsightDisplayOptions };
export default OnboardingBusinessInsight;